import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import {
  getGrnAdditionalCost,
  getParticularPage,
  getNext,
  getPrevious,
  createGrnAdditionalCost,
  updateGrnAdditionalCost,
  handleSearch,
  getGrnAdditionalCostById,
} from "./thunk";

const initialState = {
  grnAdditionalCosts: [],
  edit: false,
  grnAdditionalCost: null,
  count: null,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingUpdated: false,
  loadingGrnAdditionalCost: false,
  loadingNext: false,
  showCreateModal: false,
};

export const grnAdditionalCostSlice = createSlice({
  name: "grnAdditionalCost",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    clearAllGrnAdditionalCost: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingGrnAdditionalCost = false;
      state.grnAdditionalCost = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(createGrnAdditionalCost.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(createGrnAdditionalCost.fulfilled, (state, action) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(createGrnAdditionalCost.rejected, (state) => {
      state.loading = false;
      state.edit = false;
    });
    builder.addCase(updateGrnAdditionalCost.pending, (state) => {
      state.loadingUpdated = true;
    });
    builder.addCase(updateGrnAdditionalCost.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.edit = false;
    });
    builder.addCase(updateGrnAdditionalCost.rejected, (state) => {
      state.loadingUpdated = false;
    });
    builder.addCase(getGrnAdditionalCostById.pending, (state) => {
      state.loadingUpdated = true;
      state.edit = true;
    });
    builder.addCase(getGrnAdditionalCostById.fulfilled, (state, action) => {
      state.loadingUpdated = false;
      state.grnAdditionalCost = action.payload.data;
    });
    builder.addCase(getGrnAdditionalCostById.rejected, (state) => {
      state.loadingUpdated = false;
      state.grnAdditionalCost = null;
      state.edit = false;
    });
    builder.addMatcher(
      isAnyOf(
        getGrnAdditionalCost.pending,
        getParticularPage.pending,
        getPrevious.pending,
        getNext.pending,
        handleSearch.pending
      ),
      (state) => {
        state.loadingGrnAdditionalCost = true;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getGrnAdditionalCost.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingGrnAdditionalCost = false;
        state.grnAdditionalCosts = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getGrnAdditionalCost.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingGrnAdditionalCost = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, clearAllGrnAdditionalCost } = grnAdditionalCostSlice.actions;

export default grnAdditionalCostSlice.reducer;
